import styled, {css} from "styled-components"
import {spacingCss} from "../../global/css"

export const Container = styled.div`
  ${({theme}) => css`
    border-radius: ${theme.border.radius.large};
    background-color: ${theme.colors.utility.white};
    box-shadow: ${theme.shadows.low};
  `}
  ${spacingCss}
`
